export default __webpack_public_path__ + "static/media/Mithibai-Kshitij.29744f2e.png";